import React from 'react';
import TextItem from './Text';
import Group from './Group';
import Choice from './Choice';
import OpenChoice from './OpenChoice';
import Date from './Date';
import Decimal from './Decimal';
import Integer from './Integer';
import Display from './Display';
import { QuestionnaireItemComponent } from '../../modules/unsw-fhir/Questionnaire';

const Item = (props: QuestionnaireItemComponent) => {
  if (props.type === 'text') return <TextItem {...props} />;
  if (props.type === 'string') return <TextItem {...props} />;
  if (props.type === 'group') return <Group {...props} />;
  if (props.type === 'choice') return <Choice {...props} />;
  if (props.type === 'open-choice') return <OpenChoice {...props} />;
  if (props.type === 'date') return <Date {...props} />;
  if (props.type === 'decimal') return <Decimal {...props} />;
  if (props.type === 'integer') return <Integer {...props} />;
  if (props.type === 'display') return <Display {...props} />;
  throw new Error('Unsupported Item Type');
};

export default Item;
